import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { DateFormats } from '@uplift/constants';
import { MobileCalendarDay } from '../../components/MobileCalendarView/MobileCalendarBody/MobileCalendarDay.component';
import { MobileCalendarDayProps } from '../../components/MobileCalendarView/shared';
import { useCurrentuser, useTimezone } from '@uplift/contexts';
import { useBookedDays } from './Calendar.hooks';
import { useICSSubscriptionEventsQuery } from '@uplift/queries';
import { CalendarDateService } from '@uplift/services';


const useDayWithAvailabilityIndicatorStyles = makeStyles()(theme => ({
  dot: {
    width: '5px',
    height: '5px',
    borderRadius: '50%',
    transitionDuration: '400ms',
  },
  visible: {
    backgroundColor: theme.palette.text.secondary,
  },
  warning: {
    backgroundColor: theme.palette.warning.main,
  }
}));


export const DayWithAvailabilityIndicator: React.FC<MobileCalendarDayProps> = (props) => {
  const me = useCurrentuser();
  const timezone = useTimezone();
  const { data: ics } = useICSSubscriptionEventsQuery(me.id);
  const { classes, cx } = useDayWithAvailabilityIndicatorStyles();
  const dateStr = React.useMemo(() => props.date.format(DateFormats.ISO_DATE), [ props.date ]);
  const bookedDays = useBookedDays(dateStr, timezone);

  const hasConflict = React.useMemo(() => {
    return ics?.conflicts.some(c => CalendarDateService.date(c.appointment.fromDatetime).tz(timezone).format(DateFormats.ISO_DATE) === dateStr);
  }, [ ics, dateStr, timezone ]);

  const hasAppointments = React.useMemo(() => {
    if (!bookedDays) {
      return false;
    }

    return !!bookedDays[dateStr];
  }, [ bookedDays, dateStr ]);

  const dotClassName = cx(classes.dot, {
    [classes.visible]: hasAppointments,
    [classes.warning]: hasConflict,
  });

  return (
    <MobileCalendarDay {...props}>
      <Box className={dotClassName} />
    </MobileCalendarDay>
  );
};
